"use client";

import { useAuthoringScope } from "../authoring-scope";
import { type BreadcrumbItem, PageBreadcrumbs } from "../breadcrumbs";
import type { DrillCollection } from "./types";

export function DrillBreadcrumbs({
  collection,
  current,
}: {
  collection?: Pick<DrillCollection, "id" | "title">;
  current?: string;
}) {
  const authoring = useAuthoringScope();
  const items: BreadcrumbItem[] = authoring.admin
    ? []
    : [
        { label: "ホーム", href: "/" },
        { label: "練習", href: "/practice" },
      ];
  items.push({
    label: authoring.admin ? "運営のドリル集" : "ドリル",
    href: authoring.href("/drills"),
  });
  if (collection)
    items.push({
      label: collection.title,
      href: authoring.href(`/drills/collections/${collection.id}`),
    });
  if (current) items.push({ label: current });
  return <PageBreadcrumbs items={items} />;
}
